import * as React from 'react';
import {Link} from 'react-router-dom';

import styles from './list-summary.module.css';

type Props = {
    name: string;
    count: number;
    htmlUrl: string;
    sum: {
        formatted: string;
        prefix: string;
        suffix: string;
        value: number;
    };
};

export class ListSummary extends React.Component<Props> {
    render() {
        const {name, htmlUrl, count, sum} = this.props;

        return (
            <div className={styles.container}>
                {/* @ts-expect-error */}
                <Link to={htmlUrl} className={styles.name}>
                    {name}
                </Link>
                <div className={styles.count}>{count}</div>
                <div className={styles.value}>
                    {sum ? (
                        <span>{`${sum.prefix}${sum.formatted}${sum.suffix}`}</span>
                    ) : (
                        <span>-</span>
                    )}
                </div>
            </div>
        );
    }
}
